/* src/app/shared/reclaim/reclaim.component.css */
.min-ht {
  min-height: 20px;
}
/*# sourceMappingURL=reclaim.component.css.map */
